{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "OPC UA showcase extension",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "7e13dde5-5936-4ee5-a096-1975216608bd",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
      "nodeId": "ns=1;i=6005",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_generic.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "537055b0-d113-45a6-aa29-5906d7e590e0",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
      "nodeId": "ns=1;i=6006",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#00ff00",
      "NotAvailable": "#c8c8c8",
      "OutOfService": "#ff0000",
      "NotExecuting": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "85406f7c-f394-45ca-8c7a-1242b81c5c78",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6004",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "09327515-cf71-40cc-8548-7030288922b1",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6002",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "7e13dde5-5936-4ee5-a096-1975216608bd",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6005",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "590bf1f2-2fb7-45a5-a32d-65e4c56e71eb",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6003",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Status",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#ffffff",
                  "value": "Executing",
                  "label": "Executing"
                },
                {
                  "backgroundColor": "#c8c8c8",
                  "textColor": "#000000",
                  "value": "NotAvailable",
                  "label": "Not Available"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "OutOfService",
                  "label": "Out of Service"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "NotExecuting",
                  "label": "Not Executing"
                }
              ],
              "valueVariable": {
                "id": "537055b0-d113-45a6-aa29-5906d7e590e0",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6006",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Value",
              "showAsLink": false,
              "valueVariable": {
                "id": "db8ab7af-4201-4765-8e88-8aa4d7961c1b",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6017",
                "displayName": "Value",
                "variablePath": "Value",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Unit",
              "showAsLink": false,
              "valueVariable": {
                "id": "a2ae5551-f5b9-46dd-882f-b6adfdec2141",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
                "nodeId": "ns=1;i=6020",
                "displayName": "Unit",
                "variablePath": "Unit",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "ProcessValue_<Nr>.[PLACEHOLDER]",
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
            "nodeId": "ns=1;i=1003",
            "displayName": "ProcessValueType",
            "typeDefinition": "nsu=http://opcfoundation.org/UA/PlasticsRubber/umati/generic/;i=1003",
            "subTypes": []
          },
          "titleVariable": {
            "id": "18adbf01-3bba-4417-b8ae-59beaa477838",
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/umati/generic/",
            "nodeId": "ns=1;i=6018",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        },
        {
          "isPlaceholder": true,
          "titleVariable": {
            "id": "bfd2945e-e25b-427b-8e4c-48331fdf2cec",
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=284",
            "displayName": "ApplicationTag",
            "variablePath": "ApplicationTag",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          },
          "placeholderObject": "Monitoring.Consumption.Electricity.[PLACEHOLDER]",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Voltage",
              "valueVariable": {
                "id": "d5e22b32-ebff-41f5-b2cf-a25fada54628",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6001",
                "displayName": "AcVoltagePe",
                "variablePath": "<MeasurementValue>.AcVoltagePe.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "V"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Current",
              "valueVariable": {
                "id": "c27b257b-1644-487c-871e-da72f045c5a9",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6002",
                "displayName": "AcCurrentPe",
                "variablePath": "<MeasurementValue>.AcCurrentPe.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "A"
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Power",
              "valueVariable": {
                "id": "1123065d-0e40-4d64-98c6-e70de489eb92",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6003",
                "displayName": "AcActivePowerPe",
                "variablePath": "<MeasurementValue>.AcActivePowerPe.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customRangeHigh": 1000,
              "customRangeLow": 0,
              "customUnit": "W"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Imported Energy",
              "valueVariable": {
                "id": "0a40d4ac-6c97-4aa4-83ea-ffc6ecf2bf0f",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6004",
                "displayName": "AcActiveEnergyTotalImportHp",
                "variablePath": "<MeasurementValue>.AcActiveEnergyTotalImportHp.value",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "Wh"
            }
          ]
        }
      ]
    }
  ]
}
